<div class="page-header">
  <div class="title">Projects</div>
  <button type="button" (click)="AddProject()" class="btn btn-sm btn-primary round"><span
      class="fas fa-plus"></span></button>
  <div class="filters">
    <div class="input-group">
      <input [(ngModel)]="workflowFilterOn" (change)="FilterChange()" type="checkbox">
      <label><span [class.disabled]="!workflowFilterOn" class="fas fa-filter"></span></label>
      <input (keyup)="FilterChange()" [(ngModel)]="workflowFilter" [class.hidden]="!workflowFilterOn" placeholder="Workflow" class="form-control" type="text">
      <label [class.hidden]="workflowFilterOn">Workflow</label>
    </div>
    <div class="input-group">
      <input [(ngModel)]="statusFilterOn" type="checkbox" (change)="FilterChange()"><label><span [class.disabled]="!statusFilterOn" class="fas fa-filter"></span></label>
      <input (keyup)="FilterChange()" [(ngModel)]="statusFilter" [class.hidden]="!statusFilterOn" placeholder="Status" class="form-control" type="text">
      <label [class.hidden]="statusFilterOn">Status</label>
    </div>
    <div class="input-group">
      <input [(ngModel)]="fromDateOn" type="checkbox" (change)="FilterChange()"><label><span [class.disabled]="!fromDateOn" class="fas fa-filter"></span></label>
      <select (change)="FilterChange()" [(ngModel)]="fromDateSel" [class.hidden]="!fromDateOn" class="form-select" type="text">
        <option value="created">Created</option>
        <option value="modified">Modified</option>
        <option value="created-gt">Created &gt;</option>
        <option value="created-gte">Created &gt;=</option>
        <option value="created-lt" >Created &lt;</option>
        <option value="created-lte" >Created &lt;=</option>
        <option value="modified-gt">Modified &gt;</option>
        <option value="modified-gte">Modified &gt;=</option>
        <option value="modified-lt" >Modified &lt;</option>
        <option value="modified-lte" >Modified &lt;=</option>
      </select>
      <input (change)="FilterChange()" (keyup)="FilterChange()" [max]="today" [class.hidden]="!fromDateOn" [(ngModel)]="fromDate" class="form-control" type="date">
      <label   [class.hidden]="fromDateOn">Date</label>
    </div>
    <div [class.hidden]="!toDateAvailable" class="input-group">
      <input (change)="Refresh()" [(ngModel)]="toDateOn" type="checkbox" (change)="FilterChange()"><label><span class="fas fa-filter"></span></label>
      <select (change)="FilterChange()" [class.hidden]="!toDateOn" [(ngModel)]="toDateSel" class="form-select" type="text">
        <option value="created-gt">Created &gt;</option>
        <option value="created-gte">Created &gt;=</option>
        <option value="created-lt" [class.hidden]="!fromCreated">Created &lt;</option>
        <option value="created-lte" [class.hidden]="!fromCreated">Created &lt;=</option>
        <option value="modified-gt">Modified &gt;</option>
        <option value="modified-gte">Modified &gt;=</option>
        <option value="modified-lt" [class.hidden]="!fromModified">Modified &lt;</option>
        <option value="modified-lte" [class.hidden]="!fromModified">Modified &lt;=</option>

      </select>
      <input (change)="FilterChange()" (keyup)="FilterChange()" [max]="today" [class.hidden]="!toDateOn" [(ngModel)]="toDate" class="form-control" type="date">
      <label [class.hidden]="toDateOn">Date 2</label>
    </div>
  </div>
</div>
<div class="workarea">
  <app-project-list (onConfig)="ShowProjectConfig($event)" (onLaunch)="OpenMap($event)" [list]="projectList"></app-project-list>
</div>
<div class="page-footer"></div>
